import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { navigateTo } from 'gatsby-link';
import CookieBanner from 'react-cookie-banner';
import Media from 'react-media';

import getNewPathname from '../utils/js/getNewPathname.js';

import 'bootstrap/dist/css/bootstrap.css';
import './index.scss';

import Header from '../components/Header';
import Footer from '../components/Footer';

import cookie from './cookie.png';

const cookieStyles = {
  banner: {
    fontFamily: 'Roboto',
    height: 70,
    background: `rgba(52, 64, 81, 0.88) url(${cookie}) 20px 50% no-repeat`,
    backgroundSize: '30px 30px',
    fontSize: '15px',
    fontWeight: 600,
    zIndex: 1000,
    position: 'absolute',
    top: 63,
  },
  button: {
    border: '1px solid white',
    borderRadius: 4,
    width: 'auto',
    height: 32,
    lineHeight: '32px',
    background: 'transparent',
    color: 'white',
    fontSize: '14px',
    fontWeight: 600,
    opacity: 1,
    right: 20,
    marginTop: -20,
  },
  message: {
    display: 'block',
    padding: '15px 10% 9px 10%',
    lineHeight: 1.3,
    textAlign: 'left',
    color: 'white',
  },
  link: {
    textDecoration: 'none',
    fontWeight: 'bold',
  },
};

const cookieStylesSmall = {
  banner: {
    fontFamily: 'Roboto',
    height: 120,
    background: `rgba(52, 64, 81, 0.88)`,
    backgroundSize: '30px 30px',
    fontSize: '13px',
    fontWeight: 600,
    zIndex: 1000,
    position: 'absolute',
    top: 63,
  },
  button: {
    border: '1px solid white',
    borderRadius: 4,
    width: 'auto',
    height: 32,
    lineHeight: '32px',
    background: 'transparent',
    color: 'white',
    fontSize: '14px',
    fontWeight: 600,
    opacity: 1,
    right: 20,
    marginTop: -20,
  },
  message: {
    display: 'block',
    padding: '15px 29% 9px 10px',
    lineHeight: 1.3,
    textAlign: 'left',
    color: 'white',
  },
  link: {
    textDecoration: 'none',
    fontWeight: 'bold',
  },
};

class TemplateWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      langKey: 'fr',
    };

    this.langChange = this.langChange.bind(this);
  }

  langChange(langKey) {
    //? If pathname contient '${langkey}/blog/:postid', alors
    //? il faut récupérer :postid, récupérer id dans slugs et
    //? ajouter ou enlever '___en' en fonction de si on est
    //? initialement en fr ou en, et retrouver le slug suivant

    const regex = /blog(?=\/.)/g;

    if (regex.test(this.props.location.pathname)) {
      const slugs = this.props.data.slugs.edges;
      const pathname = this.props.location.pathname;

      const newPathname = getNewPathname(slugs, pathname, langKey);

      navigateTo(newPathname);
    } else {
      //* get pathname and redirect to new langKey
      const pathname = Array.from(this.props.location.pathname);
      pathname.splice(1, 2, langKey);

      if (pathname.join('') !== this.props.location.pathname) {
        navigateTo(pathname.join(''));
      }
    }

    this.setState({ langKey });
  }

  componentDidMount() {
    //* Get the current langkey page if it begins with /fr/ or /en
    const pathname = Array.from(this.props.location.pathname);
    const langKey = [pathname[1], pathname[2]].join('');

    if (langKey === 'fr' || langKey === 'en') {
      this.setState({ langKey });
    }
  }

  render() {
    const { langKey } = this.state;
    const { data } = this.props;

    const cookieData =
      langKey === 'fr'
        ? data.cookieFr.edges[0].node
        : data.cookieEn.edges[0].node;

    const metaDescription =
      langKey === 'fr'
        ? data.headerFr.edges[0].node.metaDescription
        : data.headerEn.edges[0].node.metaDescription;

    return (
      <div>
        <Helmet>
          <title>Offshore Services</title>
          <meta name="description" content={metaDescription} />
        </Helmet>
        <Header
          langKey={langKey}
          langChange={this.langChange}
          data={{
            fr: data.headerFr.edges[0].node,
            en: data.headerEn.edges[0].node,
          }}
          title={data.site.siteMetadata.title}
        />
        <div
          className="main"
          style={{
            marginTop: '62px',
            padding: '0',
            minHeight: '70vh',
          }}
        >
          <Media query={{ minWidth: 768 }}>
            {matches =>
              matches ? (
                <CookieBanner
                  styles={cookieStyles}
                  message={cookieData.message}
                  onAccept={() => {}}
                  link={{
                    msg: cookieData.linkMessage,
                    url: 'http://nocookielaw.com/',
                  }}
                  buttonMessage={cookieData.button}
                  cookie="user-has-accepted-cookies"
                />
              ) : (
                <CookieBanner
                  styles={cookieStylesSmall}
                  message={cookieData.message}
                  onAccept={() => {}}
                  link={{
                    msg: cookieData.linkMessage,
                    url: 'http://nocookielaw.com/',
                  }}
                  buttonMessage={cookieData.button}
                  cookie="user-has-accepted-cookies"
                />
              )
            }
          </Media>
          {this.props.children()}
        </div>
        <Footer
          langKey={langKey}
          className="container"
          data={{
            fr: data.footerFr.edges[0].node,
            en: data.footerEn.edges[0].node,
          }}
        />
      </div>
    );
  }
}

TemplateWrapper.propTypes = {
  children: PropTypes.func,
};

export default TemplateWrapper;

export const layoutQuery = graphql`
  query LayoutAndFrHeaderAndEnHeaderQuery {
    site {
      siteMetadata {
        title
        languages {
          defaultLangKey
          langs
        }
      }
    }
    # FOR HEADER (french)
    headerFr: allContentfulHeader(filter: { node_locale: { eq: "fr" } }) {
      edges {
        node {
          ...headerContent
        }
      }
    }
    # FOR HEADER (english)
    headerEn: allContentfulHeader(filter: { node_locale: { eq: "en" } }) {
      edges {
        node {
          ...headerContent
        }
      }
    }
    ##################################################################
    # FOR FOOTER (fr / en)
    footerFr: allContentfulFooter(filter: { node_locale: { eq: "fr" } }) {
      edges {
        node {
          ...footerContent
        }
      }
    }
    footerEn: allContentfulFooter(filter: { node_locale: { eq: "en" } }) {
      edges {
        node {
          ...footerContent
        }
      }
    }

    #################################################################
    #                     FOR SLUG CHANGE LANG                      #
    #################################################################
    slugs: allContentfulBlogPost {
      edges {
        node {
          id
          slug
        }
      }
    }

    #################################################################
    #                     FOR COOKIE LAW BANNER                     #
    #################################################################
    cookieFr: allContentfulCookieLawBanner(
      filter: { node_locale: { eq: "fr" } }
    ) {
      edges {
        node {
          message
          button
          linkMessage
        }
      }
    }
    cookieEn: allContentfulCookieLawBanner(
      filter: { node_locale: { eq: "en" } }
    ) {
      edges {
        node {
          message
          button
          linkMessage
        }
      }
    }
  }

  ###################################################################
  #                            FRAGMENTS                            #
  ###################################################################

  # HEADER
  fragment headerContent on ContentfulHeader {
    home
    metaDescription
    nosServices
    nosMarques
    aPropos
    choixLangue
    francais
    anglais
    logo {
      title
      file {
        url
      }
      resolutions(width: 55, height: 40, quality: 100) {
        base64
        aspectRatio
        width
        height
        src
        srcSet
        srcWebp
        srcSetWebp
      }
    }
  }

  # FOOTER
  fragment footerContent on ContentfulFooter {
    titreColonne1
    titreColonne2
    titreColonne3
    listColonne1
    listColonne2
    urlColonne1
    slugPage
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js